import { toFieldMessages } from './serverErrors';
import { ADDITIONAL_STEP, DETAILS_STEP } from './copy';

describe('management/Users toFieldMessages', () => {
  it('has nothing to say about nothing', () => {
    expect(toFieldMessages()).toEqual({ messages: {}, step: null });
    expect(toFieldMessages({})).toEqual({ messages: {}, step: null });
  });

  // The case that started this: a rejected phone number was showing as "an
  // unexpected error" instead of on the field.
  it('puts a rejected mobile on the field that collects it', () => {
    const { messages, step } = toFieldMessages({ mobile: ['must be valid'] });

    expect(messages.mobile).toEqual(`${DETAILS_STEP.mobile} must be valid`);
    expect(step).toEqual(2);
  });

  it('names the field, since Rails messages are only fragments', () => {
    const { messages } = toFieldMessages({ email: ['has already been taken'] });

    expect(messages.email).toEqual(
      `${DETAILS_STEP.email} has already been taken`,
    );
  });

  it('maps a step 3 attribute to step 3', () => {
    const { messages, step } = toFieldMessages({ postal_code: ['is invalid'] });

    expect(messages.postalCode).toEqual(
      `${ADDITIONAL_STEP.postalCode} is invalid`,
    );
    expect(step).toEqual(3);
  });

  // Landing on the later step would hide the earlier problem.
  it('lands on the earliest offending step', () => {
    const { step } = toFieldMessages({
      postal_code: ['is invalid'],
      mobile: ['must be valid'],
    });

    expect(step).toEqual(2);
  });

  it('collects a message per field', () => {
    const { messages } = toFieldMessages({
      mobile: ['must be valid'],
      state: ['is invalid'],
    });

    expect(Object.keys(messages).sort()).toEqual(['mobile', 'state']);
  });

  // Two attributes share the mobile field, and a field has room for one line.
  it('keeps the first complaint about a field', () => {
    const { messages } = toFieldMessages({
      mobile: ['must be valid', 'is bad'],
    });

    expect(messages.mobile).toEqual(`${DETAILS_STEP.mobile} must be valid`);
  });

  it('reads the legacy `emails` attribute as the email field', () => {
    const { messages, step } = toFieldMessages({
      emails: ['can not be blank'],
    });

    expect(messages.email).toBeDefined();
    expect(step).toEqual(2);
  });

  // A rule the wizard collects nothing for belongs on the generic panel; there is
  // no field to point at.
  it('leaves an unmapped attribute to the error panel', () => {
    expect(toFieldMessages({ passwords: ['are empty'] })).toEqual({
      messages: {},
      step: null,
    });
  });

  it('still lands on a step when only some attributes map', () => {
    const { messages, step } = toFieldMessages({
      password1: ['is too repetitive'],
      mobile: ['must be valid'],
    });

    expect(messages.mobile).toBeDefined();
    expect(step).toEqual(2);
  });
});
